import * as React from 'react';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
import { getContentFronStorage, isNull } from '../utils/index';
import { Link } from 'react-router-dom';
import { newI18n } from '../core/Const';
export interface Homesection3Props extends BaseComponentProps {
	lang: string;
}

export interface SliderData {
	imageUrl: string;
	slug: string;
	name: string;
	description: string;
}

export interface Homesection3tate extends BaseComponentState {
	promotions: JSX.Element[];
	segments: JSX.Element[];
	segmentsData: SliderData[];
	promotionsData: SliderData[];
}

export class Homesection3 extends BaseComponent<Homesection3Props, Homesection3tate> {
	static SLIDER_SETTING: any = {
		dots: false,
		infinite: true,
		speed: 500,
		slidesToShow: 3,
		slidesToScroll: 3,
		rows: 2,
		autoplay: true,
		responsive: [{
			breakpoint: 1200,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
				infinite: true,
				dots: true
			}
		}, {
			breakpoint: 1024,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
				infinite: true,
				dots: true
			}
		}, {
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
				initialSlide: 2
			}
		}, {
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}]
	};

	translation = {
		Title: newI18n("HOME.BALIBESTHOTELDEAL.Title", "Bali’s Best Hotel Deals "),
		SubTitle: newI18n("HOME.BALIBESTHOTELDEAL.SubTitle", "")
	};

	constructor(props: Homesection3Props) {
		super(props);
	}

	componentDidUpdate(prevProps: Homesection3Props, prevState: Homesection3tate) {
		if (prevProps.lang !== this.props.lang) {
			this.getData();
		}
	}

	componentDidMount() {
		this.getData();
	}

	getData: () => any = () => {
		let settings = Homesection3.SLIDER_SETTING;
		this.getPromotion(settings);
		this.getSegments(settings);

	}

	getPromotion(settings: any) {
		getContentFronStorage(this.props.lang, "CmsPromotion").then(
			(d: any[]) => {
				// this.setState({ data: d, requesting: false });
				if (!isNull(d)) {
					let dataSlide: SliderData[] = [];
					for (let e of d) {
						dataSlide.push({
							name: e.name,
							imageUrl: `/uploads/promotions/${e.image}`,
							slug: e.slug,
							description: e.description
						});
					}
					let slide: any[] = [];
					for (let a of dataSlide) {
						slide.push(this.createSlider(a, 'promotion_' + a.imageUrl));
					}
					this.setStateHelper(st => {
						st.promotions = slide;
						st.promotionsData = dataSlide;
					});
				}

			}).catch((exc) => { console.error('error: ', exc); }); 
	}

	getSegments(settings: any) {
		getContentFronStorage(this.props.lang, "CmsHotelSegment").then(
			(d: any[]) => {
				// this.setState({ data: d, requesting: false });
				if (!isNull(d)) {
					let dataSlide: SliderData[] = [];
					for (let e of d) {
						dataSlide.push({
							name: e.name,
							imageUrl: `/uploads/segments/${e.image}`,
							slug: e.slug,
							description: e.description
						});
					}
					let slide: any[] = [];
					for (let a of dataSlide) {
						slide.push(this.createSlider(a, 'slide_' + a.imageUrl));
					}

					this.setStateHelper(st => {
						st.segments = slide;
						st.segmentsData = dataSlide;
					});
				}

			}).catch((exc) => { console.error('error: ', exc); });
		 
	}

	createSlider(data: SliderData, key: string) {
		return (
			<div key={key} style={{ padding: 10 }} className="col-md-4 col-sm-6 col-xs-6 ">
				<div className="figure-wrapper">
					<figure className="effect-zoe">
						<Link to={data.slug}>
							<img alt={data.description} src={data.imageUrl} className="img-responsive" />
						</Link>
					</figure>
				</div>
			</div>
		);
	}

	render() {
		if (this.state.haveReactError) {
			return this.renderErrorPanel();
		}
		return (
			<section className="container-fluid container-fullw" style={{ backgroundColor: '#00aeef', fontWeight: 500, paddingBottom: 0, borderBottom: 0, }}>
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<h2 className="text-center" style={{ color: '#fff', fontWeight: 500 }} > {this.translation.Title} </h2>
							<hr />
							<h4 className="text-center" style={{ color: '#fff', fontWeight: 400 }} > {this.translation.SubTitle} </h4>
							<div className="row">
								<div data-appears-group-delay="0" data-appears-delay-increase="200">
									{this.state.promotions}
									{this.state.segments}
									<span />
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}
} 


// WEBPACK FOOTER //
// ./src/home/Homesection3.tsx